import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiGrid, FiServer, FiUsers, FiSettings, FiLogOut, FiShield, FiX, FiChevronLeft, FiChevronRight, FiCreditCard, FiRadio, FiSend, FiTrendingDown } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

export default function Sidebar({ open, setOpen, isCollapsed, setIsCollapsed }) {
  const { logout } = useAuth();

  const links = [
    { to: '/', icon: FiGrid, label: 'Dashboard' },
    { to: '/panels', icon: FiServer, label: 'Child Panels' },
    { to: '/perfect-panel/payments', icon: FiCreditCard, label: 'Perfect Panel Methods' },
    { to: '/broadcasts', icon: FiSend, label: 'Broadcasts' },
    { to: '/broadcasts/panels', icon: FiRadio, label: 'Broadcast Panels' },
    { to: '/drop-checker', icon: FiTrendingDown, label: 'Drop Checker' },
    { to: '/users', icon: FiUsers, label: 'Team Users' },
    { to: '/settings', icon: FiSettings, label: 'Settings' }
  ];

  return (
    <>
      {/* Mobile Backdrop */}
      {open && (
        <div 
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 md:hidden transition-opacity"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 bg-card border-r border-border transform transition-all duration-300 ease-in-out md:translate-x-0 flex flex-col
        ${open ? 'translate-x-0' : '-translate-x-full'} 
        ${isCollapsed ? 'w-16' : 'w-64'}
      `}>
        
        {/* Brand */}
        <div className={`h-16 flex items-center border-b border-border px-4 ${isCollapsed ? 'justify-center' : 'justify-between'}`}>
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="w-8 h-8 rounded bg-primary flex items-center justify-center flex-shrink-0">
              <FiShield size={16} className="text-primary-foreground" />
            </div>
            {!isCollapsed && (
              <span className="text-sm font-semibold tracking-tight text-foreground whitespace-nowrap">Manager Admin</span>
            )}
          </div>
          {!isCollapsed && (
            <button 
              className="md:hidden text-muted-foreground hover:text-foreground transition-colors"
              onClick={() => setOpen(false)}
            >
              <FiX size={20} />
            </button>
          )}
        </div>

        {/* Collapse Toggle for Desktop */}
        <div className="hidden md:flex justify-end p-2 relative">
           <button 
             onClick={() => setIsCollapsed(!isCollapsed)}
             className="absolute -right-3 top-4 z-50 flex h-6 w-6 items-center justify-center rounded-full border border-border bg-background text-muted-foreground hover:text-foreground shadow-sm transition-colors"
           >
             {isCollapsed ? <FiChevronRight size={14} /> : <FiChevronLeft size={14} />}
           </button>
        </div>

        {/* Nav Links */}
        <div className="flex-1 overflow-y-auto py-4 flex flex-col gap-1 px-2 overflow-x-hidden">
          {links.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              onClick={() => setOpen(false)}
              className={({ isActive }) => `
                flex items-center ${isCollapsed ? 'justify-center p-2' : 'gap-3 px-3 py-2'} rounded-md text-sm font-medium transition-colors
                ${isActive 
                  ? 'bg-secondary text-secondary-foreground' 
                  : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                }
              `}
              title={isCollapsed ? link.label : undefined}
            >
              <link.icon size={16} className="flex-shrink-0" />
              {!isCollapsed && <span className="whitespace-nowrap">{link.label}</span>}
            </NavLink>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="p-4 border-t border-border">
          <button 
            onClick={logout} 
            title={isCollapsed ? "Sign Out" : undefined}
            className={`flex items-center justify-center gap-2 rounded-md text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors text-sm font-medium
              ${isCollapsed ? 'p-2 w-full' : 'w-full px-3 py-2'}
            `}
          >
            <FiLogOut size={16} className="flex-shrink-0" />
            {!isCollapsed && <span>Sign Out</span>}
          </button>
        </div>
      </div>
    </>
  );
}
